import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PayerDto } from 'src/app/shared/models/institution/payer-dto.model';

import { IListView } from '../../../contracts/list-view';

@Component({
  selector: 'payer-list-item',
  templateUrl: 'payer-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayerListItem implements IListView {
  @Input() item: PayerDto;
  @Output() clicked: EventEmitter<PayerDto> = new EventEmitter<PayerDto>();

  public triggerEvent() {
    this.clicked.emit(this.item);
  }
}
